export interface Category {
  slug: string;
  name: string;
  en: string;
  tagline: string;
  desc: string;
  color: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "sweet",
    name: "甜宠",
    en: "Sweet Romance",
    tagline: "糖分超标的心动日常",
    desc: "高糖分恋爱日常,男女主双向奔赴、欢喜冤家、契约恋爱等甜到齁的设定,看完就想恋爱。",
    color: "bg-primary-500",
    icon: "ri-heart-3-fill",
  },
  {
    slug: "fantasy",
    name: "奇幻",
    en: "Fantasy",
    tagline: "异世界与超能力的想象力狂欢",
    desc: "穿越、魔法、异能、转生,架空世界里的冒险与成长,世界观宏大,画风华丽。",
    color: "bg-secondary-500",
    icon: "ri-sparkling-2-fill",
  },
  {
    slug: "drama",
    name: "剧情",
    en: "Drama",
    tagline: "催泪与人性的深度叙事",
    desc: "以人物命运与情感为核心的故事,跌宕起伏、后劲十足,值得反复回味的深度作品。",
    color: "bg-accent-500",
    icon: "ri-movie-2-fill",
  },
  {
    slug: "suspense",
    name: "悬疑",
    en: "Mystery",
    tagline: "层层反转的烧脑推理",
    desc: "谜题、犯罪、心理博弈,反转一个接一个,烧脑爱好者不可错过的推理佳作。",
    color: "bg-foreground-700",
    icon: "ri-mist-fill",
  },
  {
    slug: "campus",
    name: "校园",
    en: "School Life",
    tagline: "青春里的少年心事",
    desc: "教室、社团与操场边的青春故事,青涩又明亮,写尽学生时代的美好与遗憾。",
    color: "bg-secondary-400",
    icon: "ri-graduation-cap-fill",
  },
  {
    slug: "romance",
    name: "恋爱",
    en: "Romance",
    tagline: "成年人的成熟心动",
    desc: "职场、都市背景下的成年爱情,细腻克制又不乏张力,适合有阅历的你慢慢品。",
    color: "bg-primary-400",
    icon: "ri-heart-pulse-fill",
  },
  {
    slug: "action",
    name: "热血",
    en: "Action",
    tagline: "打斗与信念的高燃时刻",
    desc: "硬核战斗、热血竞技与复仇逆袭,燃到爆的剧情配上爽快的分镜,一口气看完。",
    color: "bg-accent-400",
    icon: "ri-fire-fill",
  },
  {
    slug: "healing",
    name: "治愈",
    en: "Healing",
    tagline: "温柔抚慰疲惫的心",
    desc: "生活琐碎里的小温暖,节奏舒缓、画风温柔,看完让人重新相信世界的美好。",
    color: "bg-secondary-300",
    icon: "ri-sun-foggy-fill",
  },
];

export const getCategory = (slug: string): Category =>
  categories.find((c) => c.slug === slug) ?? categories[0];